
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode'

const cookieUtils = {
    getScopeFromJWT: (cookie) => {
        try {
            const cookies = new Cookies(cookie);
            const token = cookies.get('jwt'); // Assuming the JWT cookie name is 'jwt'
            if (!token) {return {scope: null, userId: null}}
            const decodedToken = jwtDecode(token)
            const scope = decodedToken?.scope; 
            const userId = decodedToken?.userID;
            return {scope, userId};
        } catch (error) {
            console.error('Error extracting scope from JWT:', error);
            return null;
        }
    },
};

export default cookieUtils;